module.exports = __webpack_public_path__ + "static/product-1-1a7865c6a871d683c30184a4338d5ba0.png";